import { cn } from "@/lib/utils";
import { DEALER } from "@/data/dealer";
import { todayName } from "@/lib/site";

export const OpeningHours = ({ testId = "opening-hours", className }) => {
  const today = todayName();
  return (
    <div className={className}>
      <dl className="divide-y divide-line border-y border-line" data-testid={testId}>
        {DEALER.hours.map((h) => (
          <div key={h.day} className={cn("flex items-center justify-between gap-4 py-3 text-[15px]", h.day === today ? "font-semibold text-ink" : "text-steel")}>
            <dt className="flex items-center gap-2.5">
              {h.day}
              {h.day === today && <span className="rounded-sm bg-brand-soft px-1.5 py-0.5 text-xs font-bold uppercase tracking-wider text-brand">Today</span>}
            </dt>
            <dd className="tabular-nums">{h.hours}</dd>
          </div>
        ))}
      </dl>
      <p className="mt-4 text-sm text-steel">{DEALER.viewingNote}</p>
    </div>
  );
};
